<template>
  <!-- 产品选择 -->
  <el-dialog title="选择产品" width="1000px" class="my-dialog-template" :visible.sync="visible" top="0" :close-on-click-modal="false">
    <topSearchForm class="follow" @search="searchAjax()" :hiddenExport="true" :showSwtich="false">
      <el-form :inline="true">
        <el-form-item label="产品名称">
          <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品类型" prop="needProductAgreement">
          <el-select v-model="searchParams.needProductAgreement" placeholder="请选择" clearable>
            <el-option label="正常产品" value="0"></el-option>
            <el-option label="协议产品" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </topSearchForm>
    <el-table
      @selection-change="handleSelectionChange"
      :data="tableData"
      style="width: 100%"
      border
      :max-height="tableH"
      class="list-table"
      v-loading="listLoading"
      tooltip-effect="dark"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column property="name" width="450px" label="产品名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="needProductAgreement" label="产品类型" min-width="100">
        <template slot-scope="scope">
          <div class="tag2 blue" v-if="scope.row.needProductAgreement == 1">协议产品</div>
          <div class="tag2 green" v-else>正常产品</div>
        </template>
      </el-table-column>
      <el-table-column property="price" label="基础价格" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button type="danger" size="small" @click="choice(scope.row)">选择</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData.length > 0"
      class="page"
      @size-change="
        pageNum = 1;
        pageSize = $event;
        getList();
      "
      :pager-count="5"
      :current-page.sync="pageNum"
      :page-size.sync="pageSize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="getList()"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
    >
    </el-pagination>
    <div class="dialog-footer">
      <el-button type="warning" plain @click="visible = false">取消</el-button>
      <el-button type="warning" class="bgBtn" @click="productsPost()">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import topSearchForm from '@/components/topSearchForm';
import { pageTool } from '@/api/mixins';
export default {
  mixins: [pageTool],
  data: () => ({
    tableH: document.body.clientHeight - 370,
    visible: false,
    mechanId: '',
    productsId: [],
    searchParams: {
      productName: ''
    }
  }),
  components: { topSearchForm },
  created() {},
  methods: {
    open(mechanId) {
      this.mechanId = mechanId;
      this.visible = true;
      this.searchParams.productName = '';
      this.initListAjax('/master/level2/product/list');
    },
    //选择产品
    choice(row) {
      this.addMechanProduct(this.mechanId, row.id);
    },
    //团队添加选择产品
    addMechanProduct(mechanId, productsId) {
      this.$http({
        url: '/master/level2/product/add',
        type: 'post',
        params: {
          mechanId: mechanId,
          productIds: productsId
        }
      }).then(data => {
        if (data.httpCode == 200) {
          this.visible = false;
          this.$emit('reload');
        }
      });
    },
    // 单选
    handleSelectionChange(val) {
      this.productsId = val;
    },
    //多选提交
    productsPost() {
      var arr = [];
      if (this.productsId.length == 0) {
        this.$message.warning('请至少选择一个产品');
        return;
      }
      if (this.productsId.length > 0) {
        for (var i = 0; i < this.productsId.length; i++) {
          arr.push(this.productsId[i].id);
        }
      }
      this.addMechanProduct(this.mechanId, arr.join(','));
    },
    // 搜索
    search() {
      this.searchAjax();
    },
    // 自定义请求方式
    setRequstType() {
      return 'GET';
    },
    // 设置自定义参数
    setListParams(params) {
      params.productName = this.searchParams.productName;
      params.mechanId = this.mechanId;
      params.type = 2;
      this.$tools.delNull(params);
    }
  }
};
</script>
<style lang="scss" scoped>
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;
  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }
  .el-dialog__body {
    padding-top: 0;
  }
  .dialog-footer {
    margin-top: 30px;
  }
}
</style>
